// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-and-conditions__section {\n  margin-left: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
